/** The one place dates and times are rendered (#70). Ian's rulings, 2026-09-26:
 *  the device locale drives format and 12/24-hour clock; the day key is local
 *  time; the year appears only when it is not the current year. */

type DateInput = string | number | Date;

function toDate(d: DateInput): Date {
  return d instanceof Date ? d : new Date(d);
}

export function formatDate(d: DateInput, opts: { weekday?: boolean } = {}): string {
  const date = toDate(d);
  const sameYear = date.getFullYear() === new Date().getFullYear();
  return date.toLocaleDateString(undefined, {
    ...(opts.weekday && { weekday: 'short' }),
    month: 'short',
    day: 'numeric',
    ...(!sameYear && { year: 'numeric' }),
  });
}

export function formatTime(d: DateInput): string {
  return toDate(d).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
}

/** Google's "HHMM" opening-hours clock, in the device's own time format. */
export function formatClockTime(hhmm: string): string {
  const hour = parseInt(hhmm.substring(0, 2), 10);
  const minute = parseInt(hhmm.substring(2, 4), 10) || 0;
  const date = new Date();
  date.setHours(hour % 24, minute, 0, 0);
  return formatTime(date);
}

/** YYYY-MM-DD in local time. Used for "same day" grouping and the free-tier day count. */
export function localDayKey(d: DateInput): string {
  const date = toDate(d);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}
